import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, Subject } from 'rxjs';
import { ApiRequestService } from '../../../BaseFramework/core/http/api-request.service';
import { CommonUtilty } from '../../../BaseFramework/core/utilities/commonUtility';

@Injectable({
  providedIn: 'root'
})

export class SLADashboardService {

  constructor(private apiRequest: ApiRequestService,            
            private commonUtility: CommonUtilty) { }

  masterData = '1234';

  fetchCardsData(selectedDateRange){
    let fetchCards = new Subject<any>();

    this.apiRequest.postCallWithAPIMapper('fetchData', selectedDateRange)
        .subscribe(jsonResp => {
            let returnObj = this.commonUtility.deepCopy(jsonResp);
            fetchCards.next(returnObj);
        });
    return fetchCards;
  }

  fetchMonthlyWeeklyReport(){
    let fetchReport = new Subject<any>();

    this.apiRequest.get('fetchData').subscribe(jsonResp => {
            let returnObj = this.commonUtility.deepCopy(jsonResp);
            fetchReport.next(returnObj);
        });
    return fetchReport;
  }

  fetchFWADataAgainstClaimNumber(claimNum){
    let fwaForClaim = new Subject<any>();

    this.apiRequest.postCallWithAPIMapper('fetchData', claimNum)
        .subscribe(jsonResp => {
            let returnObj = this.commonUtility.deepCopy(jsonResp);
            fwaForClaim.next(returnObj);
        });
    return fwaForClaim;
  }

  fetchTriggersData(selectedTrigger){
    let fetchTriggerData = new Subject<any>();

    this.apiRequest.postCallWithAPIMapper('fetchData', selectedTrigger)
        .subscribe(jsonResp => {
            let returnObj = this.commonUtility.deepCopy(jsonResp);
            fetchTriggerData.next(returnObj);
        });
    return fetchTriggerData;
  }

}
